export const DICTIONARIES_TABLE_COLUMNS = 4
